import React from 'react'
import Title from '../common/title'

const CcwForm = ({ serviceData }) => {
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = new FormData(e.target);
        const redirectUrl = "https://square.link/u/DWhiCyyP?src=sheet";
        
        try {
            const response = await fetch('https://hook.us2.make.com/cwejmr1i531raeg4b71vkh3u9arhj31b', {
                method: 'POST',
                body: formData
            });
            
            if (response.ok) {
                // Redirect to your desired page
                window.location.href = redirectUrl;
            } else {
                alert('There was an error submitting the form. Please try again.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was an error submitting the form. Please try again.');
        }
    };

    // Fallback dates if serviceData is not available
    const fallbackDates = [
        { value: "June 28, 2025", label: "June 28, 2025 @ 9 AM - 5 PM" }
    ];

    const availableDates = serviceData?.dates || fallbackDates;
    const serviceName = serviceData?.service_name || "Enhanced Concealed Carry Class";

    return (
        <div className="contact-form-area pb-75">
            <div className="container">
                <Title 
                    sectionName={"Fill out the Form Below"} 
                    sectionTitle={`Sign Up for ${serviceName}`}
                />

                <div className="contact-form-info" data-cue="slideInUp">
                    <form onSubmit={handleSubmit}>
                        
                        <input type="hidden" name="_honey" style={{display: 'none'}} />
                        <input type="hidden" name="_captcha" value="false"/>
                        <input type="hidden" name="form_type" value="CCW" />

                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="first-name" placeholder="First Name" required />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="last-name" placeholder="Last Name" required />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="email" className="form-control" name="email" placeholder="Email" required />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="phone" placeholder="Phone" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <select name="options" id="options" className="form-control" defaultValue="" required>
                                        <option value="" disabled>Select a Date</option>
                                        {availableDates.map((date, index) => (
                                            <option key={index} value={date.value}>
                                                {date.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                       
                        <button type="submit">Register and Pay</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default CcwForm